import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { useLocation } from "react-router-dom";
import { Button, Chip, Grid } from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import API from "../../utils/Axios.utils";

const ViewSupplier = () => {
  const navigate = useNavigate();

  const location = useLocation();
  const supplierDetails = location.state?.supplierDetails;

  console.log("supplierDetails", supplierDetails);

  const [gstDwld, setGstDwld] = useState("");
  const [panDwld, setPanDwld] = useState("");
  const [cinDwld, setCinDwld] = useState("");

  const navigateToPreviousPage = () => {
    navigate(-1);
  };

  const token = JSON.parse(localStorage.getItem("userLoggedIn")).token;

  const config = {
    headers: { Authorization: `Bearer ${token}` },
  };

  const getDownloadLink = async () => {
    let url = `/api/users/supplier/view_document`;
    const data = { supplierId: supplierDetails?.supplier_id };
    try {
      const res = await API.post(url, data, config);
      setGstDwld(res?.data?.url[0]?.downloadUrl);
      setPanDwld(res?.data?.url[1]?.downloadUrl);
      setCinDwld(res?.data?.url[2]?.downloadUrl);

      //   console.log("res", res);
    } catch (error) { }
  };

  const extractFileNameFromUrl = (url) => {
    const urlParts = url.split("/");
    const lastPart = urlParts[urlParts.length - 1];
    return decodeURIComponent(lastPart);
  };

  const handleDownloadGStDoc = () => {
    console.log("gstCLicked");
    const fileName = extractFileNameFromUrl(gstDwld);

    // Create a new window or tab

    // Create a download link
    const downloadLink = document.createElement("a");
    downloadLink.href = gstDwld;
    downloadLink.download = fileName;

    // Append the link to the new tab's document body
    document.body.appendChild(downloadLink);

    // Simulate a click on the download link
    downloadLink.click();
  };

  const handleDownloadPanDoc = () => {
    console.log("panCLicked");

    const fileName = extractFileNameFromUrl(panDwld);

    // Create a new window or tab

    // Create a download link
    const downloadLink = document.createElement("a");
    downloadLink.href = panDwld;
    downloadLink.download = fileName;

    // Append the link to the new tab's document body
    document.body.appendChild(downloadLink);

    // Simulate a click on the download link
    downloadLink.click();
  };

  const handleDownloadCINDoc = () => {
    console.log("cinCLicked");

    const fileName = extractFileNameFromUrl(cinDwld);

    // Create a new window or tab
    // const newTab = window.open("", "_blank");

    // Create a download link
    const downloadLink = document.createElement("a");
    downloadLink.href = cinDwld;
    downloadLink.download = fileName;

    // Append the link to the new tab's document body
    document.body.appendChild(downloadLink);

    // Simulate a click on the download link
    downloadLink.click();
  };

  useEffect(() => {
    getDownloadLink();
  }, []);

  return (
    <div
      style={{
        marginTop: 20,
      }}
    >
      <Button startIcon={<ArrowBackIcon />} onClick={navigateToPreviousPage}>
        Back
      </Button>
      <div
        style={{
          border: "1px solid #989898",
          borderRadius: "10px",
          padding: "15px",
        }}
      >
        <div
          style={{
            fontFamily: "Roboto, Helvetica, Arial, sans-serif",
            fontSize: "20px",
            fontWeight: "500",
            letterSpacing: 1,
            textAlign: "left",
          }}
        >
          <span
            style={{
              fontSize: "20px",
              fontWeight: 550,
            }}
          >
            View Supplier
          </span>
          <div style={{ display: "grid" }}>
            <Grid container spacing={2}>
              <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
                <span style={{ fontSize: "16px", fontWeight: 600 }}>
                  First Name
                </span>

                <div>{supplierDetails?.supplier_admin_name || null}</div>
              </Grid>
              <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
                <span style={{ fontSize: "16px", fontWeight: 600 }}>
                  Last Name
                </span>

                <div>{supplierDetails?.supplier_last_name || null}</div>
              </Grid>
              <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
                <span style={{ fontSize: "16px", fontWeight: 600 }}>
                  Phone Number
                </span>

                <div>{supplierDetails?.supplier_admin_mobile || null}</div>
              </Grid>
              <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
                <span style={{ fontSize: "16px", fontWeight: 600 }}>
                  Supplier Code
                </span>
                <div>{supplierDetails?.supplier_code || null}</div>
              </Grid>
              <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
                <span style={{ fontSize: "16px", fontWeight: 600 }}>
                  Supplier Organisation Name
                </span>

                <div>{supplierDetails?.supplier_org_name || null}</div>
              </Grid>
              <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
                <span style={{ fontSize: "16px", fontWeight: 600 }}>
                  Zip Code
                </span>

                <div>{supplierDetails?.pincode || null}</div>
              </Grid>
              <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
                <span style={{ fontSize: "16px", fontWeight: 600 }}>
                  Country
                </span>

                <div>{supplierDetails?.country || null}</div>
              </Grid>
              <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
                <span style={{ fontSize: "16px", fontWeight: 600 }}>State</span>
                <div>{supplierDetails?.state || null}</div>
              </Grid>

              <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
                <span style={{ fontSize: "16px", fontWeight: 600 }}>City</span>
                <div>{supplierDetails?.city || null}</div>
              </Grid>

              <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
                <span style={{ fontSize: "16px", fontWeight: 600 }}>
                  Preferred Supplier
                </span>
                <div>{supplierDetails?.is_preffered_supplier || null}</div>
              </Grid>

              <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
                <span style={{ fontSize: "16px", fontWeight: 600 }}>
                  Referred By
                </span>
                <div>{supplierDetails?.referred_by || null}</div>
              </Grid>

              <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
                <span style={{ fontSize: "16px", fontWeight: 600 }}>
                  Additional Email
                </span>
                <div>{supplierDetails?.supplier_additional_email || null}</div>
              </Grid>

              <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
                <span style={{ fontSize: "16px", fontWeight: 600 }}>
                  GST Number
                </span>
                <div>{supplierDetails?.gst_number || null}</div>
              </Grid>

              <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
                <span style={{ fontSize: "16px", fontWeight: 600 }}>
                  PAN Number
                </span>
                <div>{supplierDetails?.pan_number || null}</div>
              </Grid>

              <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
                <span style={{ fontSize: "16px", fontWeight: 600 }}>CIN</span>
                <div>{supplierDetails?.CIN || null}</div>
              </Grid>

              <Grid item xl={8} lg={8} md={6} sm={12} xs={12}>
                <span style={{ fontSize: "16px", fontWeight: 600 }}>
                  Business Address
                </span>
                <div>{supplierDetails?.business_address || null}</div>
              </Grid>

              <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                <span style={{ fontSize: "16px", fontWeight: 600 }}>
                  Core Skills
                </span>
                {/* <div>{supplierDetails?.skills.join(", ") || null}</div> */}
                <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
                  {supplierDetails?.coreSkills?.map(skill => (
                    <Chip
                      key={skill.id}
                      label={skill.name}
                      size="medium"
                      variant="outlined"
                      sx={{
                        height: 36,
                        fontSize: '0.95rem',
                        '& .MuiChip-label': { px: 1.5 }
                      }}
                    />
                  ))}
                </div>
              </Grid>
              {/* File Upload */}
              <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                <div
                  style={{
                    marginTop: 20,
                    border: "1px solid #989898",
                    borderRadius: "10px",
                    padding: "15px",
                  }}
                >
                  <Grid container>
                    <Grid container spacing={2} sx={{ marginTop: "3px" }}>
                      {/* 1st Column */}
                      <Grid item xl={3} lg={3} md={3} sm={12} xs={12}>
                        GST Document
                      </Grid>

                      <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                        {supplierDetails.gst_doc}
                      </Grid>

                      <Grid
                        item
                        xl={3}
                        lg={3}
                        md={3}
                        sm={12}
                        xs={12}
                        display="flex"
                        justifyContent="flex-end"
                      >
                        <Button
                          variant="contained"
                          startIcon={<DownloadIcon />}
                          onClick={handleDownloadGStDoc}
                        >
                          Download
                        </Button>
                      </Grid>
                    </Grid>
                    <Grid container spacing={2} sx={{ marginTop: "3px" }}>
                      {/* 1st Column */}
                      <Grid item xl={3} lg={3} md={3} sm={12} xs={12}>
                        PAN Document
                      </Grid>

                      <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                        {supplierDetails.pan_doc}
                      </Grid>

                      <Grid
                        item
                        xl={3}
                        lg={3}
                        md={3}
                        sm={12}
                        xs={12}
                        display="flex"
                        justifyContent="flex-end"
                      >
                        <Button
                          variant="contained"
                          startIcon={<DownloadIcon />}
                          onClick={handleDownloadPanDoc}
                        >
                          Download
                        </Button>
                      </Grid>
                    </Grid>
                    <Grid container spacing={2} sx={{ marginTop: "3px" }}>
                      {/* 1st Column */}
                      <Grid item xl={3} lg={3} md={3} sm={12} xs={12}>
                        CIN Document
                      </Grid>

                      <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                        {supplierDetails.CIN_doc}
                      </Grid>

                      <Grid
                        item
                        xl={3}
                        lg={3}
                        md={3}
                        sm={12}
                        xs={12}
                        display="flex"
                        justifyContent="flex-end"
                      >
                        <Button
                          variant="contained"
                          startIcon={<DownloadIcon />}
                          onClick={handleDownloadCINDoc}
                        >
                          Download
                        </Button>
                      </Grid>
                    </Grid>
                  </Grid>
                </div>
              </Grid>
            </Grid>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewSupplier;
